<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>渠道统计</h1>
        <p>按现有渠道档案、代金券和结算单汇总。没有按月的消耗金额、使用积分和活跃渠道口径。</p>
      </div>
    </div>
    <div class="ch-metrics five">
      <div class="ch-metric" v-for="item in levels" :key="item.code">
        <div class="k">{{ item.name }}</div>
        <div class="v">{{ item.count }}</div>
        <div class="s">已通过 {{ item.approved }}</div>
      </div>
    </div>
    <div class="ch-panel">
      <h2>渠道明细</h2>
      <table class="ch-table">
        <thead><tr><th>渠道商</th><th>级别</th><th>区域</th><th>状态</th></tr></thead>
        <tbody>
          <tr v-for="row in partners" :key="row.id">
            <td>{{ row.name }}</td>
            <td>{{ levelName(row.levelCode) }}</td>
            <td>{{ row.regionName || '—' }}</td>
            <td><span class="ch-tag" :class="row.status === 'APPROVED' ? 'ok' : 'warn'">{{ statusName(row.status) }}</span></td>
          </tr>
          <tr v-if="!partners.length"><td colspan="4" class="ch-empty">还没有渠道</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getChannelPartners } from '@/api/admin'
import { LEVELS, levelName, statusName } from '../partner/labels'

export default {
  name: 'HqStats',
  data() { return { partners: [] } },
  computed: {
    levels() {
      return Object.keys(LEVELS).map(code => {
        const rows = this.partners.filter(item => item.levelCode === code)
        return { code, name: LEVELS[code], count: rows.length, approved: rows.filter(item => item.status === 'APPROVED').length }
      })
    }
  },
  created() { this.load() },
  methods: {
    levelName, statusName,
    async load() {
      const partners = await getChannelPartners()
      this.partners = partners.list || []
    }
  }
}
</script>
